import Vue from 'vue';

const state = {
    data: [],
};

const getters = {
    getBlocks(state) {
        return state.data;
    }
};

const mutations = {
    SET_DATA(state, users) {
        state.data = users;
    },
};

const actions = {

    loadBlocks({dispatch, commit}) {

        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().get("/wp/v2/house-blocks")
                .then(({data}) => {

                    const blockRows = [];
                    // console.log(data);

                    data.forEach((block) => {

                        blockRows.push({
                            id: block.id,
                            title: block.title.rendered,
                            images: block.acf.images.length,
                            video: block.acf.video,
                        })
                    });

                    commit('SET_DATA', blockRows);
                    resolve();

                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        });

    },

    loadOneBlock({dispatch, commit}, blockId) {

        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().get("/wp/v2/house-blocks/" + blockId)
                .then(({data: block}) => {

                    const blockRow = {
                        id: block.id,
                        title: block.title.rendered,
                        images: block.acf.images,
                        video: block.acf.video
                    };

                    commit('SET_DATA', blockRow);
                    resolve();

                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        });

    }

};

export const blocks = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};